import { getTolerance } from "./moveto"

export const sidebarInit = (data) => {
    const side = document.querySelector(".Sidebard")

    if (side && innerWidth > 1024) {

        //カレント表示
        const lis = side.querySelectorAll(".Sidebard__menu ul li"),
            cnts = side.querySelectorAll(".Sidebard__cnt [id]");
        setTimeout(() => {
            scroll()
        }, 500)
        window.addEventListener("scroll", scroll)

        function scroll() {
            if (window.barbaInfo.move == data) {

                let already = false;
                let offsetHeight = 0;

                cnts.forEach((cnt, index) => {
                    let cntPos = cnt.getBoundingClientRect()
                    let nmt = cnt.nextElementSibling ? parseInt(getComputedStyle(nmt = cnt.nextElementSibling).marginTop) : 0
                    if (cntPos.top <= getTolerance().tolerance + getTolerance().offset && cntPos.bottom >= offsetHeight + getTolerance().tolerance - nmt + getTolerance().offset && !already) {
                        lis[index].classList.add("crnt")
                        already = true
                    } else {
                        lis[index].classList.remove("crnt")
                    }
                })
            }
        }

        //アニメーション
        const ul = side.querySelector("ul")
        const menu = side.querySelector(".Sidebard__menu")
        const cnt = side.querySelector(".Sidebard__cnt")

        animeScroll()
        window.removeEventListener("scroll", animeScroll)
        window.addEventListener("scroll", animeScroll)

        function animeScroll() {

            let menuInfo = menu.getBoundingClientRect()

            let centerOffset = (menuInfo.top + menuInfo.height / 2) - innerHeight / 2
            console.log(centerOffset)

            ul.style.transform = `translate3d(0%,${clamp(-centerOffset, -(getTolerance().tolerance + getTolerance().offset), getTolerance().tolerance + getTolerance().offset)}px,0)`;
        }
    }
}

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}